import React from 'react'
import StaticHeader from './StaticHeader';
import StaticFooter from './StaticFooter';
import './StaticPages.css'
 


function ContactPage() {
    return (
        <>
            <StaticHeader />
            <div className='service-container'>
                <div className='service-banner'>
                    <div className='title-align'> Contact Us </div>
                </div>
            </div>
            <div className='contact-page'>
              <p className='contact-page-para'>
                    Our dedicated customer service team can help you to find the right test that you need and answer any questions along the way.
</p>
<p className='contact-page-para'>
                    If your question requires a medical professional, we will liaise with our team of expert medical doctors to get you the answer.
                    </p>
                    <p className='contact-page-para'>
                    You can talk to us over the phone, via email, chat or social media.
                    </p>
                    <p className='contact-page-para'>
                    We are available - Monday - Friday: 9am - 5pm and Saturday: 9am - 2pm
                    </p>
                    <p className='contact-page-para'>
                    Call: +234 9010996000
                    </p>
                    <p className='contact-page-para'>
                    Email: info@doctall.com
                    </p>
                    <p className='contact-page-para'>
                    WhatsApp:+2349010996341
                    </p>
                    <p className='contact-page-para'>
                    Facebook: Doctall
                    </p>
                    <p className='contact-page-para'>
                    Instagram: mydoctall
                    </p>
                    <p className='contact-page-para'>
                    Alternatively, you can use our contact form here.
                    </p>
                    <p className='contact-page-para'>
                    You can also chat to us by clicking on the help pop up link on the right-hand corner of the screen. If we are not available to chat, you can leave us your contact details and we will get in touch as soon as we are available again.
                    </p>
                    <p className='contact-page-para'>
                    The  frequently asked questions might find the answer you are looking for, but we know  at sometimes it's nice to talk to  an expert and get the right information .
                    </p>

                   
                   
                
            </div>
            <StaticFooter />
        </>

    )
}

export default ContactPage
